import React from 'react';
import { T } from '../tokens';
import { useTheme } from '../theme';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'soft';
type Size = 'sm' | 'md' | 'lg';

export interface BtnProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'style'> {
  variant?: Variant;
  size?: Size;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  full?: boolean;
  style?: React.CSSProperties;
}

export function Btn({ children, variant = 'primary', size = 'md', icon, iconRight, full, style = {}, disabled, ...rest }: BtnProps) {
  const t = useTheme();
  const sizes: Record<Size, React.CSSProperties> = {
    sm: { height: 38, padding: '0 14px', fontSize: 13 },
    md: { height: 46, padding: '0 18px', fontSize: 14 },
    lg: { height: 52, padding: '0 22px', fontSize: 15 },
  };
  const variants: Record<Variant, React.CSSProperties> = {
    primary: { background: t.accent, color: T.onAccent, border: '1px solid transparent' },
    secondary: { background: T.surface, color: T.fg, border: `1.5px solid ${T.border}` },
    ghost: { background: 'transparent', color: T.fg2, border: '1px solid transparent' },
    danger: { background: T.error, color: T.onAccent, border: '1px solid transparent' },
    soft: { background: T.accentLight, color: t.accent, border: '1px solid transparent' },
  };
  return (
    <button disabled={disabled} {...rest} style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      fontFamily: T.font, fontWeight: 700, borderRadius: t.radius,
      cursor: disabled ? 'not-allowed' : 'pointer',
      whiteSpace: 'nowrap', width: full ? '100%' : 'auto', transition: 'all 160ms ease',
      ...sizes[size], ...variants[variant],
      ...(disabled ? { background: T.disabledBg, color: T.disabledFg, border: '1px solid transparent' } : {}),
      ...style,
    }}>{icon}{children}{iconRight}</button>
  );
}
